import React, { createContext, useState, useContext, useEffect } from 'react';

// 建立一個 Context 物件
const AuthContext = createContext(null);

// 建立一個提供 Context 的組件
export const AuthProvider = ({ children }) => {
    // 從 localStorage 初始化 token，如果沒有則為 null
    const [token, setTokenState] = useState(() => localStorage.getItem('accessToken'));

    // 建立一個函式來設定 token，同時更新 state 和 localStorage
    const setToken = (newToken) => {
        if (newToken) {
            localStorage.setItem('accessToken', newToken);
            setTokenState(newToken);
        } else {
            // 如果傳入 null 或 undefined，則清除 token
            localStorage.removeItem('accessToken');
            setTokenState(null);
        }
    };

    // 確保在組件加載時，狀態與 localStorage 同步
    useEffect(() => {
        const storedToken = localStorage.getItem('accessToken');
        if (storedToken !== token) {
            setTokenState(storedToken);
        }
    }, [token]);


    return (
        <AuthContext.Provider value={{ token, setToken }}>
            {children}
        </AuthContext.Provider>
    );
};

// 建立一個自定義 Hook，方便其他組件使用 AuthContext
export const useAuth = () => {
    return useContext(AuthContext);
};